import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppShell from './app/AppShell';
import { Provider } from 'react-redux';
import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import store from './state/store/appStore';

const appTheme = createTheme({
  typography: {
    fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
  },
  palette: {
    primary: {
      main: '#1e4d92',
      dark: '#123c7b',
      light: '#2458a5',
      contrastText: '#ffffff',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 999,
          letterSpacing: '0.01em',
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #1e4d92 0%, #123c7b 100%)',
          boxShadow: '0 4px 10px rgba(18, 60, 123, 0.16)',
        },
        outlinedPrimary: {
          color: '#123c7b',
          borderColor: '#2a5a9f',
          backgroundColor: '#f5f8ff',
        },
        textPrimary: {
          color: '#123c7b',
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <Provider store={store}>
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <AppShell />
    </ThemeProvider>
  </Provider>
  );


